import { MenuItem, Select } from '@mui/material'
import { Button, Col, Form, Grid, Input, InputMask, Row, SelectForm, Span } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { Control } from 'react-hook-form'
import { SPACING } from 'utils'
import { TipoPendencia } from 'utils/types'

interface IFilterPendingItems {
  control: Control<TipoPendencia>
  handleSubmit: any
  handleClearButton: () => void
  handleSearch: (_form?: TipoPendencia) => void
}
export const FilterPendingItems = ({
  control,
  handleSubmit,
  handleClearButton,
  handleSearch
}: IFilterPendingItems) => {
  return (
    <Form onSubmit={handleSubmit(handleSearch)}>
      <Grid gridCols="1fr 1fr 2.5fr 3.5fr" gridGap="0.5625rem">
        <Input
          label="Código"
          placeholder="Cód."
          name="idTipoPendencia"
          formValue="idTipoPendencia"
          min={0}
          mask={['#######']}
          control={control}
        />
        <Col>
          <SelectForm
            label="Tipo"
            control={control}
            formValue='txTipo'
            listOptions={[
              { label: 'Trabalhista', value: 'Trabalhista' },
              { label: 'Previdenciário', value: 'Previdenciário' },
              { label: 'Outros', value: 'Outros' },
              { label: 'Todos', value: 'Todos' },
            ]}
          />
        </Col>
        <Input
          label="Pendência"
          placeholder="Nome da Pendência"
          name="txDescricao"
          formValue="txDescricao"
          control={control}
          maxLength={250}
          marginLeft={SPACING.spacing15}
        />
        <Row
          alignItems="center"
          justifyContent="flex-end"
          marginTop={SPACING.spacing15}
        >
          <Button
            text="Limpar"
            onClick={handleClearButton}
            variantButton="text"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
          />
          <Button
            endIcon={<MagnifyingGlassIcon />}
            text="Pesquisar"
            type={'submit'}
            marginLeft={SPACING.spacing15}
          />
        </Row>
      </Grid>
    </Form>
  )
}
